module.exports = __webpack_public_path__ + "static/ic-empty-news-7a87ac220b805a6a435fba11c900de96.png";